export default __webpack_public_path__ + "static/media/dimond_kinetics.66153cbe.png";